import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
type Size = 'sm' | 'md';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
}

const VARIANT: Record<Variant, string> = {
  primary: 'bg-accent text-accent-fg hover:opacity-90 focus:ring-accent',
  secondary:
    'bg-surface-alt text-ink border border-border hover:bg-border focus:ring-accent',
  danger: 'bg-danger text-danger-fg hover:opacity-90 focus:ring-danger',
  ghost: 'text-ink-muted hover:text-ink hover:bg-surface-alt focus:ring-accent',
};

const SIZE: Record<Size, string> = {
  sm: 'text-xs px-2.5 py-1 rounded',
  md: 'text-sm px-4 py-2 rounded',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', className = '', children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      className={`inline-flex items-center justify-center font-medium transition focus:outline-none focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT[variant]} ${SIZE[size]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});
